// extracted by mini-css-extract-plugin
export default {"tab":"DirectionTab_tab__cLxpj","tabInactive":"DirectionTab_tabInactive__4tFxg","tabActive":"DirectionTab_tabActive__Ji5nm","dark":"DirectionTab_dark__Zeo+s"};